import { render, staticRenderFns } from "./ModalCategories.vue?vue&type=template&id=40ef3380&"
import script from "./ModalCategories.vue?vue&type=script&lang=js&"
export * from "./ModalCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports